import React from 'react';

interface Alert {
  id: string;
  type: 'error' | 'warning' | 'info';
  title: string;
  message: string;
  timestamp: string;
  queueName?: string;
}

interface AlertsListProps {
  alerts: Alert[];
}

const AlertsList: React.FC<AlertsListProps> = ({ alerts }) => {
  const getAlertIcon = (type: string) => {
    switch (type) {
      case 'error': return '🚨';
      case 'warning': return '⚠️';
      case 'info': return 'ℹ️';
      default: return '📢';
    }
  };

  const formatTimestamp = (timestamp: string) => {
    return new Date(timestamp).toLocaleString('es-ES', {
      hour: '2-digit',
      minute: '2-digit',
      day: '2-digit',
      month: '2-digit',
    });
  };

  if (!alerts.length) {
    return (
      <div className="alerts-empty">
        <p>✅ No hay alertas recientes</p>
      </div>
    );
  }

  return (
    <div className="alerts-list">
      {alerts.map((alert) => (
        <div key={alert.id} className={`alert-item alert-${alert.type}`}>
          <div className="alert-header">
            <span className="alert-icon">{getAlertIcon(alert.type)}</span>
            <span className="alert-title">{alert.title}</span>
            <span className="alert-timestamp">{formatTimestamp(alert.timestamp)}</span>
          </div>
          <div className="alert-body">
            <p className="alert-message">{alert.message}</p>
            {alert.queueName && (
              <span className="alert-queue">Cola: {alert.queueName}</span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default AlertsList;
